import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from "../../../shared/store/common/component-store-v2.factory";
import { FilterBuilder } from '../../../content/helper/filter.builder';
import { selectFiscalYearFrag } from './organization-year-select.query';
import { InfiniteScrollStore } from '../../../shared/store/common/infinite-scroll.store';
import { FiscalYearObject } from '@libs/types/src/mado/object-type/organization/fiscal-year.object';
import { localStorageFiscalYearIdKey } from 'packages/client/src/app/utils/local-storage.utils';

@Injectable()
export class OrganizationYearSelectStore extends ComponentStoreV2Factory {

    public readonly selectedOrganizationId = computed(() => this.globalGlobalStore.organizationStore.selectedId());

    public fiscalYearsScroll = computed(() => new InfiniteScrollStore<FiscalYearObject>(
        this.api.getFiscalYears,
        FilterBuilder.singlePage({ organizationId: this.globalGlobalStore.organizationStore.selectedId() }),
        true,
        selectFiscalYearFrag,
    ))

    // set selected fiscal year in global store
    public setFiscalYearId(yearId: number): void {
        this.globalGlobalStore.organizationStore.selectedFiscalYearId.set(yearId); // for use on FE
        localStorage.setItem(localStorageFiscalYearIdKey, yearId.toString()); // for header for BE
    }
}
